import { IdentifierKey, ObjectIdentifierKey } from './identifiers';
import { typeOf } from '@ember/utils';

export const CREATED_IN_CIO_AT = '_created_in_customerio_at';
export const RESTRICTED_ATTRIBUTES = [
  IdentifierKey.Id,
  IdentifierKey.Email,
  CREATED_IN_CIO_AT,
  'anonymous_id',
  'created_at',
  'email_sha256',
  'mobile_ad_id',
  'mobile_ad_id_sha256',
  'unsubscribed',
];
export const RESTRICTED_EVENT_ATTRIBUTES = ['from_address', 'reply_to', 'recipient'];
export const PERMANENT_ATTRIBUTES = [
  IdentifierKey.CioId,
  IdentifierKey.Id,
  IdentifierKey.Email,
  'created_at',
  CREATED_IN_CIO_AT,
];
export const PERMANENT_OBJECT_ATTRIBUTES = [
  ObjectIdentifierKey.CioObjectId,
  ObjectIdentifierKey.ObjectId,
  'created_at',
  CREATED_IN_CIO_AT,
  'name',
];
export const IMMUTABLE_OBJECT_ATTRIBUTES = [
  CREATED_IN_CIO_AT,
  ObjectIdentifierKey.CioObjectId,
  ObjectIdentifierKey.ObjectId,
];
export const ATTRIBUTES_TO_IGNORE_FOR_TIMESTAMPS = [IdentifierKey.Id, 'phone'];
export const PROTECTED_ATTRIBUTES = ['id', '_timestamp'];
export const REQUIRED_EVENT_IMPORT_ATTRIBUTES = {
  name: '_cio_name',
  customer_id: '_cio_customer_id',
  timestamp: '_cio_timestamp',
};
export const CIO_SUBSCRIPTION_PREF_KEY = 'cio_subscription_preferences';

export function isJSONAttribute(value: unknown) {
  if (value == null) {
    return false;
  }

  let type = typeOf(value) as string;

  if (type === 'object' || type === 'array') {
    return true;
  }

  if (type !== 'string') {
    return false;
  }

  try {
    // Strings like "1" or "null" pass the parse step, but we're only interested
    // in actual objects or arrays
    let parsedValue = JSON.parse(value as string);
    let parsedType = typeOf(parsedValue) as string;

    return parsedType === 'object' || parsedType === 'array';
  } catch {
    return false;
  }
}

export function toJSONAttribute(value: unknown) {
  if (!isJSONAttribute(value)) {
    throw new Error(`Value ${value} is not JSON-like`);
  }

  let type = typeOf(value) as string;

  if (type === 'object' || type === 'array') {
    return value;
  }

  return JSON.parse(value as string);
}
